module.exports = __webpack_public_path__ + "static/media/1017118.c076fcd7.png";